<template>
  <div>
    <source-layer v-model="sourceLayer" :validated="validated"></source-layer>

    <b-row v-if="validated && (bufferSizeIsEmpty || bufferSizeIsInvalid)">
      <b-col offset="3" cols="9">
        <small class="text-danger" v-if="bufferSizeIsEmpty">
          Należy podać wielkość bufora.
        </small>
        <small class="text-danger" v-else>
          Wielkość bufora nie może być ujemna.
        </small>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col cols="3">
        <label for="bufferSize">Wielkość bufora</label>
      </b-col>
      <b-col cols="9">
        <b-form-input
          id="bufferSize"
          type="number"
          v-model.number="bufferSize"
          placeholder="Wpisz"
          min="0"
          max="255"
          :state="
            validated && (bufferSizeIsEmpty || bufferSizeIsInvalid)
              ? false
              : null
          "
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row v-if="validated && selectedBufferStyleIsEmpty">
      <b-col offset="3" cols="9">
        <small class="text-danger">
          Należy wybrać styl bufora.
        </small>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col cols="3">
        <label for="bufferStyleSelect">Styl bufora</label>
      </b-col>
      <b-col cols="9">
        <b-form-select
          id="bufferStyleSelect"
          v-model="selectedBufferStyle"
          :options="bufferStyles"
          :state="validated && selectedBufferStyleIsEmpty ? false : null"
        >
          <template slot="first">
            <option :value="null">Wybierz</option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row v-if="validated && selectedConnectionStyleIsEmpty">
      <b-col offset="3" cols="9">
        <small class="text-danger">
          Należy wybrać styl połączenia.
        </small>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col cols="3">
        <label for="connectionTypeSelect">Styl połączenia</label>
      </b-col>
      <b-col cols="9">
        <b-form-select
          id="connectionTypeSelect"
          v-model="selectedConnectionStyle"
          :options="connectionStyles"
          :state="validated && selectedConnectionStyleIsEmpty ? false : null"
        >
          <template slot="first">
            <option :value="null">Wybierz</option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SourceLayer from './SourceLayer';
import { Api as ApiAnalysis } from '../../api/api-analizy';
import { WINDOW_NOTIFICATION_SHOW } from '../../store/mutations.type';
import {
  TEMPORARY_LAYER_ADD,
  MAP_SELECTION_CLEAR
} from '../../store/actions.type';

export default {
  components: {
    SourceLayer
  },
  props: {
    hasErrors: { type: Boolean, default: false },
    waitingForResponse: Boolean
  },
  data() {
    return {
      sourceLayer: null,
      bufferStyles: [
        { text: 'Tępe', value: 'flat' },
        { text: 'Kwadratowe', value: 'square' },
        { text: 'Zaokrąglone', value: 'round' }
      ],
      selectedBufferStyle: 'round',
      connectionStyles: [
        { text: 'Zaokrąglone', value: 'round' },
        { text: 'Ostre', value: 'mitre' }
      ],
      selectedConnectionStyle: 'round',
      bufferSize: null,
      validated: false
    };
  },
  computed: {
    sourceLayerTypeIsEmpty() {
      return !this.sourceLayer;
    },
    bufferSizeIsEmpty() {
      return this.bufferSize === null || this.bufferSize === '';
    },
    bufferSizeIsInvalid() {
      return !this.bufferSizeIsEmpty && this.bufferSize < 0;
    },
    selectedBufferStyleIsEmpty() {
      return !this.selectedBufferStyle;
    },
    selectedConnectionStyleIsEmpty() {
      return !this.selectedConnectionStyle;
    },
    formHasErrors() {
      return (
        this.sourceLayerIsEmpty ||
        this.bufferSizeIsEmpty ||
        this.bufferSizeIsInvalid ||
        this.selectedBufferStyleIsEmpty ||
        this.selectedConnectionStyleIsEmpty
      );
    }
  },
  watch: {
    formHasErrors(value) {
      this.$emit('update:hasErrors', value);
    }
  },
  methods: {
    async submit() {
      this.validated = true;

      if (!this.formHasErrors) {
        const analysisData = {
          warstwa_id: this.$store.getters.featuresLayer.id,
          join_style: this.selectedConnectionStyle,
          cap_style: this.selectedBufferStyle,
          distance: this.bufferSize
        };

        if (this.sourceLayer.type === 'selection') {
          analysisData.feature_ids_filter = [
            ...this.$store.getters.selectedMapFeatures
          ];

          if (!analysisData.feature_ids_filter.length) {
            this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
              type: 'warn',
              title: 'Uwaga. Nie zaznaczono obiektów.',
              message:
                'Nie można wykonać analizy z powodu braku zaznaczonych obiektów.',
              duration: 5000
            });

            return;
          }
        }

        try {
          this.$emit('update:waitingForResponse', true);
          const api = new ApiAnalysis();
          const response = await api.postAnalizyBuforWarstwa({
            wso2_id: this.contextEmail ? this.contextEmail : null,
            orgid: this.contextOrganizationId
              ? this.contextOrganizationId
              : null,
            body: analysisData
          });

          if (this.$store.getters.spatialAnalysisModalVisible) {
            this.$store.dispatch(TEMPORARY_LAYER_ADD, response.body);
          }
        } catch (e) {
          if (this.$store.getters.spatialAnalysisModalVisible) {
            this.$store.commit(WINDOW_NOTIFICATION_SHOW, 'Błąd połączenia.');
          }
        } finally {
          this.$emit('update:waitingForResponse', false);
          this.$store.dispatch(MAP_SELECTION_CLEAR);
        }
      } else {
        this.$emit('update:hasErrors', true);
      }
    }
  }
};
</script>
